import { h, RectNode, RectNodeModel } from '@logicflow/core';

// 自定义矩形节点（实体）
export class CustomRectNode extends RectNode {
  // 重写getText方法来支持多行文本显示
  getText() {
    const { model } = this.props;
    const { text } = model;

    if (!text || !text.value) {
      return null;
    }

    // 处理多行文本
    const textLines = text.value.split('\n');
    const lineHeight = 16; // 行高
    const totalHeight = (textLines.length - 1) * lineHeight;
    
    // 如果只有一行文本，使用父类的默认渲染
    if (textLines.length === 1) {
      return super.getText();
    }

    // 多行文本渲染
    return h(
      'g',
      {
        className: 'lf-node-text-group',
      },
      textLines.map((line, index) => 
        h(
          'text',
          {
            x: text.x,
            y: text.y - totalHeight / 2 + index * lineHeight,
            fill: '#000000',
            textAnchor: 'middle',
            dominantBaseline: 'middle',
            style: {
              fontSize: 14,
              userSelect: 'none',
            },
            key: `line-${index}`,
          },
          line
        )
      )
    );
  }
}

export class CustomRectNodeModel extends RectNodeModel {
  getTextStyle() {
    const style = super.getTextStyle();
    return {
      ...style,
      color: '#000000',
      overflowMode: 'default' as any,
      // lineHeight: 1.2,
      fontSize: 14,
    };
  }
}
